function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1383",
  "data-name": "Group 1383",
  transform: "translate(-574.512 -788.347)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Block-Chart_1",
  "data-name": "Block-Chart 1",
  transform: "translate(596.607 792.301)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1330",
  "data-name": "Group 1330",
  transform: "translate(7.908)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_789",
  "data-name": "Path 789",
  d: "M3.977,118.616A1.868,1.868,0,0,1,2,116.639V1.977A1.868,1.868,0,0,1,3.977,0,1.868,1.868,0,0,1,5.954,1.977V116.639A1.868,1.868,0,0,1,3.977,118.616Z",
  transform: "translate(-2)",
  fill: "#d5d5d5"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1331",
  "data-name": "Group 1331",
  transform: "translate(0 106.754)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_790",
  "data-name": "Path 790",
  d: "M116.639,30.954H1.977a1.977,1.977,0,1,1,0-3.954H116.639a1.977,1.977,0,1,1,0,3.954Z",
  transform: "translate(0 -27)",
  fill: "#d5d5d5"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1332",
  "data-name": "Group 1332",
  transform: "translate(23.723 43.492)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_791",
  "data-name": "Path 791",
  d: "M23.792,62.4H7.977A1.868,1.868,0,0,1,6,60.423V12.977A1.868,1.868,0,0,1,7.977,11H23.792a1.868,1.868,0,0,1,1.977,1.977V60.423A1.868,1.868,0,0,1,23.792,62.4ZM9.954,58.446H21.815V14.954H9.954Z",
  transform: "translate(-6 -11)",
  fill: "#d5d5d5"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1333",
  "data-name": "Group 1333",
  transform: "translate(86.985 27.677)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_792",
  "data-name": "Path 792",
  d: "M39.792,74.216H23.977A1.868,1.868,0,0,1,22,72.239V8.977A1.868,1.868,0,0,1,23.977,7H39.792a1.868,1.868,0,0,1,1.977,1.977V72.239A1.868,1.868,0,0,1,39.792,74.216ZM25.954,70.262H37.815V10.954H25.954Z",
  transform: "translate(-22 -7)",
  fill: "#d5d5d5"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1334",
  "data-name": "Group 1334",
  transform: "translate(55.354 3.954)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_793",
  "data-name": "Path 793",
  d: "M31.792,91.939H15.977A1.868,1.868,0,0,1,14,89.962V2.977A1.868,1.868,0,0,1,15.977,1H31.792a1.868,1.868,0,0,1,1.977,1.977V89.962A1.868,1.868,0,0,1,31.792,91.939ZM17.954,87.985H29.815V4.954H17.954Z",
  transform: "translate(-14 -1)",
  fill: "#d5d5d5"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1382",
  "data-name": "Group 1382",
  transform: "translate(575.915 789.75)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_69",
  "data-name": "Line 69",
  y1: 119.332,
  x2: 154.545,
  transform: "translate(3.705 1.749)",
  fill: "none",
  stroke: "#d5d5d5",
  strokeLinecap: "round",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_70",
  "data-name": "Line 70",
  y1: 120.843,
  x2: 156.501,
  transform: "translate(0 0)",
  fill: "none",
  stroke: "#f5f5f5",
  strokeLinecap: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_774",
  "data-name": "Path 774",
  d: "M0,120.843,156.5,0",
  transform: "translate(3.499 3.499)",
  fill: "none",
  stroke: "#f5f5f5",
  strokeLinecap: "round",
  strokeWidth: 2
})));

var SvgNoChartData = function SvgNoChartData(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162.805,
    height: 127.147,
    viewBox: "0 0 162.805 127.147",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoChartData, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-chart-data.74d9e453.svg";
export { ForwardRef as ReactComponent };